import { useEffect, useRef, useState } from 'react';
import { createDeal } from './deals-api';

// Модальное окно создания сделки. Обязателен только клиент; регион — по желанию.
export function NewDealModal({
  onClose,
  onCreated,
  title = 'Новая сделка',
  subtitle = 'номер · этап · юрлицо система проставит сама',
}: {
  onClose: () => void;
  onCreated: (id: number) => void;
  title?: string;
  subtitle?: string;
}) {
  const [client, setClient] = useState('');
  const [region, setRegion] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    const name = client.trim();
    if (!name) {
      setMsg('Укажите клиента.');
      inputRef.current?.focus();
      return;
    }
    setBusy(true);
    setMsg(null);
    try {
      const d = await createDeal(name, region.trim() || undefined);
      onCreated(d.id);
    } catch {
      setMsg('Не удалось создать сделку. Попробуйте ещё раз.');
      setBusy(false);
    }
  }

  return (
    <div className="ovl" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 460 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-h">
          <div className="grow">
            <div className="m-cli">{title}</div>
            <div className="m-no">{subtitle}</div>
          </div>
          <button className="icon-btn close-x" onClick={onClose}>
            ✕
          </button>
        </div>
        <form className="mbody" onSubmit={submit}>
          {msg && <p className="err">{msg}</p>}
          <label className="fld">
            <span className="fld-l">
              Клиент <span className="req">*</span>
            </span>
            <input
              ref={inputRef}
              value={client}
              disabled={busy}
              placeholder="ТОО «Иртыш-Агро»"
              onChange={(e) => setClient(e.target.value)}
            />
          </label>
          <label className="fld">
            <span className="fld-l">Регион</span>
            <input
              value={region}
              disabled={busy}
              placeholder="напр. Костанайская обл. (необязательно)"
              onChange={(e) => setRegion(e.target.value)}
            />
          </label>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 6 }}>
            <button type="button" className="btn ghost sm" disabled={busy} onClick={onClose}>
              Отмена
            </button>
            <button type="submit" className="btn sm" disabled={busy}>
              {busy ? 'Создаём…' : 'Создать сделку'}
            </button>
          </div>
          <p className="muted small" style={{ marginTop: 10 }}>
            Состав заказа и план платежей заполняются в карточке после создания.
          </p>
        </form>
      </div>
    </div>
  );
}
